/* FLOODIE — single deferred module. Vanilla, no deps. Phase 3-5.
   Budget-conscious: reveals, lazy video with single-decoder rule,
   colourway sequence, PDP helpers. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || {};
  var noAutoplay = reduced || conn.saveData === true || /(^|\b)(2g|3g)\b/.test(conn.effectiveType || '');

  /* ---------- reveals: once only ---------- */
  function reveals() {
    var els = document.querySelectorAll('.fl-reveal, .fl-lines');
    if (!('IntersectionObserver' in window) || reduced) {
      els.forEach(function (e) { e.classList.add('fl-in', 'fl-lines-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add(en.target.classList.contains('fl-lines') ? 'fl-lines-in' : 'fl-in');
          io.unobserve(en.target); /* never re-trigger */
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- video: attach after load, one decoder at a time ---------- */
  var playing = null;
  function attachVideo(v) {
    if (v.dataset.flAttached) return;
    var mp4 = v.dataset.mp4, webm = v.dataset.webm;
    if (v.dataset.mobileMp4 && window.matchMedia('(max-width: 767px)').matches) { mp4 = v.dataset.mobileMp4; webm = ''; }
    if (webm) { var s1 = document.createElement('source'); s1.src = webm; s1.type = 'video/webm'; v.appendChild(s1); }
    if (mp4) { var s2 = document.createElement('source'); s2.src = mp4; s2.type = 'video/mp4'; v.appendChild(s2); }
    v.dataset.flAttached = '1';
    v.load();
  }
  function videos() {
    var vids = document.querySelectorAll('video[data-fl-video]');
    if (!vids.length || noAutoplay) return; /* posters remain */
    var start = function () { setTimeout(observe, 800); }; /* attach only after full load + idle: poster stays the LCP */
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
    function observe() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          attachVideo(v);
          if (playing && playing !== v) playing.pause();
          playing = v;
          v.play().catch(function () {});
        } else { v.pause(); if (playing === v) playing = null; }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
    }
  }

  /* ---------- colourways: FloodieGallery drives the cycle; this syncs bg tone,
       panel highlight and the one-decoder video rule. Panels stay real anchors. ---------- */
  function colourways() {
    var seq = document.querySelector('[data-fl-colourways]');
    if (!seq) return;
    var panels = Array.prototype.slice.call(seq.querySelectorAll('[data-fl-panel]'));
    var gal = seq.querySelector('floodie-gallery');
    if (!panels.length) return;
    var apply = function (i, slide) {
      var p = panels[i]; if (!p) return;
      seq.style.setProperty('--fl-cw-bg', p.dataset.flTone || 'var(--sherpa)');
      panels.forEach(function (x, xi) { x.classList.toggle('is-on', xi === i); });
      var v = slide && slide.querySelector('video[data-fl-video]');
      seq.querySelectorAll('video[data-fl-video]').forEach(function (x) { if (x !== v) x.pause(); });
      if (v && !noAutoplay) { attachVideo(v); v.play().catch(function () {}); }
    };
    seq.addEventListener('fg:change', function (e) { apply(e.detail.index, e.detail.slide); });
    /* hovering a colour pins its slide (gallery auto-resumes via resume-after) */
    panels.forEach(function (p, i) {
      p.addEventListener('pointerenter', function () {
        if (gal && gal.goTo) { if (gal._userTakeover) gal._userTakeover(); gal.goTo(i); }
      });
    });
    apply(0, seq.querySelector('[data-fg-slide]'));
  }

  /* ---------- PDP: sticky ATC — Ritual's native bar is used; just patch its a11y name ---------- */
  function stickyAtc() {
    var rb = document.querySelector('sticky-add-to-cart button');
    if (rb && !rb.getAttribute('aria-label')) rb.setAttribute('aria-label', 'Add to cart');
  }

  /* ---------- PDP: size chart modal ---------- */
  function sizeModal() {
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-fl-size-open]');
      var close = e.target.closest('[data-fl-size-close]');
      var modal = document.querySelector('[data-fl-size-modal]');
      if (!modal) return;
      if (open) { e.preventDefault(); modal.hidden = false; modal.querySelector('button,[href]').focus(); document.body.style.overflow = 'hidden'; }
      if (close || (e.target === modal)) { modal.hidden = true; document.body.style.overflow = ''; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { var m = document.querySelector('[data-fl-size-modal]'); if (m && !m.hidden) { m.hidden = true; document.body.style.overflow = ''; } }
    });
  }

  /* ---------- PDP: one-tap Duo add ---------- */
  function duoAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fl-duo-add]');
      if (!btn) return;
      e.preventDefault();
      var form = document.querySelector('form[action^="/cart/add"]');
      var idInput = form && form.querySelector('[name="id"]');
      if (!idInput) return;
      btn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: +idInput.value, quantity: 2 }] })
      }).then(function (r) { return r.json(); }).then(function () {
        btn.removeAttribute('aria-busy');
        btn.textContent = btn.dataset.flDone || 'Two added — 20% comes off at checkout';
        var live = document.querySelector('[data-fl-live]');
        if (live) live.textContent = 'Two Floodies added to cart. Duo discount applies automatically at checkout.';
        window.location.href = '/cart';
      }).catch(function () { btn.removeAttribute('aria-busy'); });
    });
  }

  /* ---------- delivery estimate ---------- */
  function delivery() {
    var el = document.querySelector('[data-fl-delivery]');
    if (!el) return;
    var cutoff = +(el.dataset.cutoffHour || 14);
    var now = new Date();
    var dispatch = new Date(now);
    if (now.getHours() >= cutoff) dispatch.setDate(dispatch.getDate() + 1);
    while ([0, 6].indexOf(dispatch.getDay()) !== -1) dispatch.setDate(dispatch.getDate() + 1);
    var arrive = new Date(dispatch); arrive.setDate(arrive.getDate() + +(el.dataset.transitDays || 3));
    while ([0].indexOf(arrive.getDay()) !== -1) arrive.setDate(arrive.getDate() + 1);
    var fmt = function (d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); };
    var hrs = cutoff - now.getHours();
    el.textContent = (hrs > 0 ? 'Order within ' + hrs + 'h — ' : '') + 'dispatched ' + fmt(dispatch) + ', arrives by ' + fmt(arrive) + '.';
  }

  /* ---------- announcement rotator ---------- */
  function announce() {
    var rot = document.querySelector('[data-fl-announce]');
    if (!rot) return;
    var msgs = rot.querySelectorAll('span');
    if (msgs.length < 2 || reduced) return;
    var i = 0;
    setInterval(function () {
      msgs[i].style.display = 'none';
      i = (i + 1) % msgs.length;
      msgs[i].style.display = 'inline';
    }, 4000);
  }

  function init() { reveals(); videos(); colourways(); stickyAtc(); sizeModal(); duoAdd(); delivery(); announce(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
